import React, { useCallback, useState } from "react";

const TIME_SLOT_OPTIONS = [
  { key: "morning", label: "朝" },
  { key: "afternoon", label: "昼" },
  { key: "night", label: "夜" },
  { key: "custom", label: "細かく設定" },
];

const HOUR_OPTIONS = Array.from({ length: 24 }, (_, i) => i);

const SearchFormTimeSlots = ({ timeSlot, onChangeTimeSlot }) => {
  const [customFrom, setCustomFrom] = useState(9);
  const [customTo, setCustomTo] = useState(21);

  const toggleSlot = useCallback(
    (slotKey) => {
      if (slotKey === "custom") {
        if (timeSlot === "custom") {
          onChangeTimeSlot(null);
        } else {
          onChangeTimeSlot("custom", { from: customFrom, to: customTo });
        }
      } else {
        onChangeTimeSlot(timeSlot === slotKey ? null : slotKey);
      }
    },
    [timeSlot, onChangeTimeSlot, customFrom, customTo]
  );

  const onChangeFrom = useCallback(
    (e) => {
      const val = parseInt(e.target.value, 10);
      setCustomFrom(val);
      onChangeTimeSlot("custom", { from: val, to: customTo });
    },
    [customTo, onChangeTimeSlot]
  );

  const onChangeTo = useCallback(
    (e) => {
      const val = parseInt(e.target.value, 10);
      setCustomTo(val);
      onChangeTimeSlot("custom", { from: customFrom, to: val });
    },
    [customFrom, onChangeTimeSlot]
  );

  return (
    <>
      {TIME_SLOT_OPTIONS.map(({ key, label }) => (
        <button
          key={key}
          className={`btn btn-sm rounded-pill ${
            timeSlot === key ? "btn-secondary" : "btn-outline-secondary"
          } px-3 mr-2`}
          style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}
          onClick={() => toggleSlot(key)}
        >
          {label}
        </button>
      ))}
      {timeSlot === "custom" && (
        <div className="d-flex align-items-center ml-2" style={{ fontSize: "0.85rem" }}>
          <select
            className="form-control form-control-sm"
            style={{ width: "80px" }}
            value={customFrom}
            onChange={onChangeFrom}
          >
            {HOUR_OPTIONS.map((h) => (
              <option key={h} value={h}>{h}:00</option>
            ))}
          </select>
          <span className="mx-1">〜</span>
          <select
            className="form-control form-control-sm"
            style={{ width: "80px" }}
            value={customTo}
            onChange={onChangeTo}
          >
            {HOUR_OPTIONS.map((h) => (
              <option key={h} value={h}>{h}:00</option>
            ))}
          </select>
        </div>
      )}
    </>
  );
};

export default SearchFormTimeSlots;